import React from 'react';
import { BookingsLists } from 'acscp/components/bookings/bookingsLists';
import { PageHeader } from 'acscp/components/common/pageHeader';
import { withPageLayout } from 'acscp/components/layout/pageLayout';
import { FormattedMessage } from 'react-intl';
import style from 'acscp/components/bookings/bookingsLists.module.scss';
import { NewFlightRequestButton } from '../flightRequest/newFlightRequestButton';
import { AppState } from 'acscp/store';
import { userCanPotentiallyRequestFlights } from 'acscp/store/helpers/authHelper';
import { connect } from 'react-redux';

interface InjectedStateProps {
    canPotentiallyRequestFlights: boolean;
}

const BookingsListPagePresentational: React.SFC<InjectedStateProps> = ({canPotentiallyRequestFlights}) => {
    return (
        <div className={style.ExpandAllParentDiv}>
            {canPotentiallyRequestFlights &&
                <div className={style.NewEnquiryWrapper}>
                    <NewFlightRequestButton centreAlign={true} />
                </div>
            }
            <PageHeader
                title={
                    <FormattedMessage
                        id={'components.pages.bookingsList.title'}
                        defaultMessage={'MY CHARTERS'}
                    />
                }
            />
            <BookingsLists />
        </div>
    );
};

function mapStateToProps(state: AppState, ownProps: {}): InjectedStateProps {
    return {
        canPotentiallyRequestFlights: userCanPotentiallyRequestFlights(state.auth),
    };
}

const BookingsListPage = connect(mapStateToProps)(BookingsListPagePresentational);

const BookingsList = withPageLayout(BookingsListPage, true);
export { BookingsList, BookingsListPage, BookingsListPagePresentational };
